import { MessageDescriptor } from 'react-intl';

import { PartnerDetails } from '@/components/b2b/shared/types';
import { trialDurationMap } from '@/components/dtcPartnerships/shared/types';
import { FlowConfig } from '@/components/SimplifiedSignup/Context/types';

import { FlowScreenNames } from '../../types';
import ControlScreenConfig from '../Control/Screens';
import { generatePartnerScreenConfigs } from './Screens';

export const partnerConfigGenerator = (
	partner: PartnerDetails | null,
	formatMessage: (
		message: MessageDescriptor,
		placeholders?: Record<string, string | number | undefined>,
	) => string,
): FlowConfig => {
	return {
		activeScreenKey: 'account' as FlowScreenNames,
		activeScreenConfig: ControlScreenConfig.account,
		name: `dtc-partnership-${partner?.name}`,
		pageName: 'dtc-partnership',
		promotion: partner?.name.toLowerCase(),
		screens: generatePartnerScreenConfigs(partner ?? null, formatMessage),
		...(partner?.logo_url ? { coBranded: { src: partner?.logo_url, alt: `${partner.name} Logo` } } : {}),
		plan: partner?.offer_details?.billing_plan?.includes('1m') ? 'monthly' : 'yearly',
		coupon: partner?.offer_details?.stripe_coupon ?? null,
		hasFreeTrial: Boolean(partner?.offer_details?.trial_duration),
		freeTrialLength: partner?.offer_details?.trial_duration
			? trialDurationMap[partner?.offer_details?.trial_duration].duration
			: 0,
		freeTrialLengthUnit: partner?.offer_details?.trial_duration
			? trialDurationMap[partner?.offer_details?.trial_duration].unit
			: null,
		offerCountries: null,
		offerCurrencies: null,
		allowChurned: true,
	};
};
